// eslint-disable-next-line import-x/no-unassigned-import
import './.test/bootstrap';

import { createLogger } from '@svenskaspelab/nova-core/log';

const logger = createLogger('account-tur.instrumentation');

logger.debug('App initialized');
